import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import * as signalR from "@microsoft/signalr";
import { SystemChat } from "./type";
import { Result } from "../../types/Result";
import { User } from "../user/type";

export const systemChatLoader: LoaderFunction = async (args) => {
  const [result, userResult] = await Promise.all([
    axiosApi.get(
      `/api/systemChats?filters[0].field=userId&filters[0].operator=eq&filters[0].value=${args.params.userId}&sort.Field=creationTime&sort.Sort=desc&pageNumber=1&pageSize=10`
    ),
    // Başlıkta kullanıcı adı için; bulunamazsa sayfa yine açılır
    axiosApi
      .get<Result<User>>(`/api/users/${args.params.userId}`)
      .catch(() => null),
  ]);
  const hubUrl = `${process.env.REACT_APP_API_WEB_SOCKET}/chathub/system?userId=${args.params.userId}`;
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, {
      accessTokenFactory: () => localStorage.getItem("jwtToken") || "",
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(signalR.LogLevel.Information)
    .build();
  await connection.start();
  connection.onreconnecting((error) => {
    console.log("SignalR bağlantısı yeniden kuruluyor:", error);
  });

  connection.onreconnected((connectionId) => {
    console.log("SignalR bağlantısı yeniden kuruldu:", connectionId);
  });

  connection.onclose((error) => {
    console.log("SignalR bağlantısı kapandı:", error);
  });
  // Bağlantıyı başlat
  console.log("SignalR bağlantısı kuruldu");

  return { data: result.data, connection, user: userResult?.data.data ?? null };
};
